import React from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import { Link } from 'react-router-dom';
import Testimonial from '../component/Testimonial';

const page = () => {
    return (
        <div className="main-wrapper">

            <Header />

            {/* <!-- Hero Start --> */}
            <div className="section techwix-hero-section-05">
                <div className="techwix-hero-wrap"
                    style={{ backgroundImage: "url(/images/bg/hero-bg5.jpg)" }}
                >
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                {/* <!-- Hero Content Start --> */}
                                <div className="hero-content">
                                    <h3 className="sub-title" data-aos-delay="600" data-aos="fade-up">your network becomes easier to operate by ai</h3>
                                    <h2 className="title" data-aos="fade-up" data-aos-delay="800">Take the next steps for an <span>AI-driven</span> enterprise.</h2>
                                    <p data-aos="fade-up" data-aos-delay="900">We provide the most responsive and functional IT</p>
                                    <div className="hero-btn" data-aos="fade-up" data-aos-delay="1000">
                                        <Link className="btn" to="/about">Read More</Link>
                                    </div>
                                </div>
                                {/* <!-- Hero Content End --> */}
                            </div>
                            <div className="col-lg-6">
                                {/* <!-- Hero Image Start --> */}
                                <div className="hero-images">
                                    <div className="images">
                                        <img src="/images/hero-img.png" alt="" />
                                    </div>
                                </div>
                                {/* <!-- Hero Image ennd --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Hero End --> */}

            {/* <!-- About Start --> */}
            <div className="section techwix-about-section-05 section-padding">
                <div className="container">
                    {/* <!-- About Wrap Start --> */}
                    <div className="about-wrap">
                        <div className="section-title text-center">
                            <h3 className="sub-title">Who we are</h3>
                            <h2 className="title">An artificial intelligence company that excels in visual recognition, solving real-world problems for businesses.</h2>
                        </div>
                        {/* <!-- About Content Wrap Start --> */}
                        <div className="about-content-wrap">
                            <div className="row">
                                <div className="col-lg-6">
                                    {/* <!-- About Image Wrap Start --> */}
                                    <div className="about-img-wrap">
                                        <div className="about-img about-img-big">
                                            <img src="/images/about-big3.jpg" alt="" />
                                        </div>
                                        <div className="about-img about-img-sm">
                                            <img src="/images/about-sm3.jpg" alt="" />
                                            <div className="shape-01"></div>
                                        </div>
                                    </div>
                                    {/* <!-- About Image Wrap End --> */}
                                </div>
                                <div className="col-lg-6">
                                    {/* <!-- About Content Start --> */}
                                    <div className="about-content">
                                        <p className="title">Accelerate innovation with world-className tech teams We’ll match you to an entire remote team of incredible freelance talent</p>
                                        <p className="text">Accelerate innovation with world-className tech teams We’ll match you to an entire remote team of incredible freelance talent for all your software development needs.</p>
                                        {/* <!-- About List Item Wrap Start --> */}
                                        <div className="about-list-item-wrap">
                                            <div className="about-list-item">
                                                <div className="about-img">
                                                    <img src="/images/about-icon1.png" alt="" />
                                                </div>
                                                <div className="about-text">
                                                    <h3 className="title">Augmented Reality</h3>
                                                    <p>Accelerate innovation with world-className tech teams</p>
                                                </div>
                                            </div>
                                            <div className="about-list-item">
                                                <div className="about-img">
                                                    <img src="/images/about-icon2.png" alt="" />
                                                </div>
                                                <div className="about-text">
                                                    <h3 className="title">Data Resolving</h3>
                                                    <p>Accelerate innovation with world-className tech teams</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!-- About List Item Wrap End --> */}
                                    </div>
                                    {/* <!-- About Content End --> */}
                                </div>
                            </div>
                        </div>
                        {/* <!-- About Content Wrap End --> */}
                    </div>
                    {/* <!-- About Wrap End --> */}
                </div>
            </div>
            {/* <!-- About End --> */}

            {/* <!-- Service Start --> */}
            <div className="section techwix-service-section-05">
                <div className="container">
                    {/* <!-- Service Wrap Start --> */}
                    <div className="service-wrap section-padding-02">
                        <div className="section-title text-center">
                            <h3 className="sub-title">Whats included in service</h3>
                            <h2 className="title">Building everything you need for your business</h2>
                        </div>
                        <div className="service-content-wrap">
                            <div className="row">
                                <div className="col-xl-3 col-sm-6">
                                    {/* <!-- Service Item Start --> */}
                                    <div className="service-item-04">
                                        <div className="service-img">
                                            <img src="/images/ser-icon13.png" alt="" />
                                        </div>
                                        <div className="service-content">
                                            <h3 className="title"><Link href="/service">AI base business solution</Link></h3>
                                            <p>Accelerate innovation with world-className tech teams We’ll match you to an entire remote team .</p>
                                        </div>
                                    </div>
                                    {/* <!-- Service Item End --> */}
                                </div>
                                <div className="col-xl-3 col-sm-6">
                                    {/* <!-- Service Item Start --> */}
                                    <div className="service-item-04">
                                        <div className="service-img">
                                            <img src="assets/images/ser-icon14.png" alt="" />
                                        </div>
                                        <div className="service-content">
                                            <h3 className="title"><Link href="/service">Chatbot with Real meeting</Link></h3>
                                            <p>Accelerate innovation with world-className tech teams We’ll match you to an entire remote team .</p>
                                        </div>
                                    </div>
                                    {/* <!-- Service Item End --> */}
                                </div>
                                <div className="col-xl-3 col-sm-6">
                                    {/* <!-- Service Item Start --> */}
                                    <div className="service-item-04">
                                        <div className="service-img">
                                            <img src="/images/ser-icon15.png" alt="" />
                                        </div>
                                        <div className="service-content">
                                            <h3 className="title"><Link href="/service">Automate data saving</Link></h3>
                                            <p>Accelerate innovation with world-className tech teams We’ll match you to an entire remote team .</p>
                                        </div>
                                    </div>
                                    {/* <!-- Service Item End --> */}
                                </div>
                                <div className="col-xl-3 col-sm-6">
                                    {/* <!-- Service Item Start --> */}
                                    <div className="service-item-04">
                                        <div className="service-img">
                                            <img src="/images/ser-icon16.png" alt="" />
                                        </div>
                                        <div className="service-content">
                                            <h3 className="title"><Link href="/service">Robotic Automation</Link></h3>
                                            <p>Accelerate innovation with world-className tech teams We’ll match you to an entire remote team .</p>
                                        </div>
                                    </div>
                                    {/* <!-- Service Item End --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Service Wrap End --> */}
                </div>
            </div>
            {/* <!-- Service End --> */}

            {/* <!-- Counter Start --> */}
            <div className="section techwix-counter-section-03"
                style={{ backgroundImage: "url(/images/bg/counter-bg.jpg)" }}
            >
                <div className="container">
                    <div className="counter-wrap">
                        <div className="row">
                            <div className="col-lg-3 col-sm-6">
                                {/* <!-- Single Counter Start --> */}
                                <div className="single-counter-02 text-center">
                                    <span><span className="counter">354</span>+</span>
                                    <p>Completed Projects</p>
                                </div>
                                {/* <!-- Single Counter End --> */}
                            </div>
                            <div className="col-lg-3 col-sm-6">
                                {/* <!-- Single Counter Start --> */}
                                <div className="single-counter-02 text-center">
                                    <span><span className="counter">119</span>+</span>
                                    <p>Robotic Automation</p>
                                </div>
                                {/* <!-- Single Counter End --> */}
                            </div>
                            <div className="col-lg-3 col-sm-6">
                                {/* <!-- Single Counter Start --> */}
                                <div className="single-counter-02 text-center">
                                    <span><span className="counter">99</span>%</span>
                                    <p>Web Site Analyse</p>
                                </div>
                                {/* <!-- Single Counter End --> */}
                            </div>
                            <div className="col-lg-3 col-sm-6">
                                {/* <!-- Single Counter Start --> */}
                                <div className="single-counter-02 text-center">
                                    <span><span className="counter">321</span>+</span>
                                    <p>Clients Supoort Done</p>
                                </div>
                                {/* <!-- Single Counter End --> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Counter End --> */}

            {/* <!-- Solution Start --> */}
            <div className="section techwix-solution-section section-padding">
                <div className="container">
                    {/* <!-- Solution Wrap Start --> */}
                    <div className="solution-wrap">
                        <div className="section-title text-center">
                            <h3 className="sub-title"> WE Deliver Excellence</h3>
                            <h2 className="title">Solutions To Common AI Problems</h2>
                        </div>
                        {/* <!-- Solution Content Wrap Start --> */}
                        <div className="solution-content-wrap">
                            <div className="row">
                                <div className="col-lg-7">
                                    {/* <!-- Solution Item Start --> */}
                                    <div className="solution-item solution-item-big">
                                        <div className="solution-img">
                                            <Link href="#"><img src="/images/solution-1.jpg" alt="" /></Link>
                                        </div>
                                        <div className="solution-content">
                                            <div className="solution-title">
                                                <h4 className="sub-title">Machine</h4>
                                                <h3 className="title"><Link href="#">Categorizing Airbnb Listing Photos Using Tensorflow</Link></h3>
                                            </div>
                                            <Link className="play-btn popup-video" href="https://www.youtube.com/watch?time_continue=3&v=_X0eYtY8T_U"><i className="fas fa-play"></i></Link>
                                        </div>
                                    </div>
                                    {/* <!-- Solution Item End --> */}
                                </div>
                                <div className="col-lg-5">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            {/* <!-- Solution Item Start --> */}
                                            <div className="solution-item solution-item-sm">
                                                <div className="solution-img">
                                                    <Link href="#"><img src="/images/solution-img2.jpg" alt="" /></Link>
                                                </div>
                                                <div className="solution-content">
                                                    <div className="solution-title">
                                                        <h4 className="sub-title">Data Mining</h4>
                                                        <h3 className="title"><Link href="#">Generative Adversarial Networks With Ml</Link></h3>
                                                    </div>
                                                    <Link className="play-btn popup-video" href="https://www.youtube.com/watch?time_continue=3&v=_X0eYtY8T_U"><i className="fas fa-play"></i></Link>
                                                </div>
                                            </div>
                                            {/* <!-- Solution Item End --> */}
                                        </div>
                                        <div className="col-lg-12">
                                            {/* <!-- Solution Item Start --> */}
                                            <div className="solution-item solution-item-sm">
                                                <div className="solution-img">
                                                    <Link href="#"><img src="/images/solution-img3.jpg" alt="" /></Link>
                                                </div>
                                                <div className="solution-content">
                                                    <div className="solution-title">
                                                        <h4 className="sub-title">Data Mining</h4>
                                                        <h3 className="title"><Link href="#">Generative Adversarial Networks With Ml</Link></h3>
                                                    </div>
                                                    <Link className="play-btn popup-video" href="https://www.youtube.com/watch?time_continue=3&v=_X0eYtY8T_U"><i className="fas fa-play"></i></Link>
                                                </div>
                                            </div>
                                            {/* <!-- Solution Item End --> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- Solution Content Wrap End --> */}
                    </div>
                    {/* <!-- Solution Wrap End --> */}
                </div>
            </div>
            {/* <!-- Solution End --> */}

            {/* <!-- Testimonial Start  --> */}
            <div className="section bg-cover techwix-testimonial-section-02 techwix-testimonial-section-03 section-padding"
                style={{ backgroundImage: "url(/images/bg/testi-bg4.jpg)" }}
            >
                <Testimonial />
            </div>
            {/* <!-- Testimonial End  --> */}

            {/* <!-- Brand Logo Start --> */}
            <div className="section techwix-brand-section techwix-brand-section-03 techwix-brand-section-04 section-padding">
                <div className="container">
                    {/* <!-- Brand Wrapper Start --> */}
                    <div className="brand-wrapper text-center">

                        {/* <!-- Brand Active Start --> */}
                        <div className="brand-active">
                            <div className="swiper-container">
                                <div className="swiper-wrapper">
                                    {/* <!-- Single Brand Start --> */}
                                    <div className="swiper-slide single-brand">
                                        <img src="/images/brand/brand-1.png" alt="Brand" />
                                    </div>
                                    {/* <!-- Single Brand End --> */}
                                    {/* <!-- Single Brand Start --> */}
                                    <div className="swiper-slide single-brand">
                                        <img src="/images/brand/brand-2.png" alt="Brand" />
                                    </div>
                                    {/* <!-- Single Brand End --> */}
                                    {/* <!-- Single Brand Start --> */}
                                    <div className="swiper-slide single-brand">
                                        <img src="/images/brand/brand-3.png" alt="Brand" />
                                    </div>
                                    {/* <!-- Single Brand End --> */}
                                    {/* <!-- Single Brand Start --> */}
                                    <div className="swiper-slide single-brand">
                                        <img src="/images/brand/brand-4.png" alt="Brand" />
                                    </div>
                                    {/* <!-- Single Brand End --> */}
                                    {/* <!-- Single Brand Start --> */}
                                    <div className="swiper-slide single-brand">
                                        <img src="/images/brand/brand-5.png" alt="Brand" />
                                    </div>
                                    {/* <!-- Single Brand End --> */}
                                    {/* <!-- Single Brand Start --> */}
                                    <div className="swiper-slide single-brand">
                                        <img src="/images/brand/brand-2.png" alt="Brand" />
                                    </div>
                                    {/* <!-- Single Brand End --> */}
                                </div>
                            </div>
                        </div>
                        {/* <!-- Brand Active End --> */}
                    </div>
                    {/* <!-- Brand Wrapper End --> */}
                </div>
            </div>
            {/* <!-- Brand Logo End --> */}

            {/* <!-- Cta Start --> */}
            <div className="section techwix-cta-section-03">
                <div className="container">
                    {/* <!-- Cta Wrap Start --> */}
                    <div className="cta-wrap"
                        style={{ backgroundImage: "url(/images/bg/cta-bg2.jpg)" }}
                    >
                        <div className="row align-items-center">
                            <div className="col-lg-7">
                                {/* <!-- Cta Content Start --> */}
                                <div className="cta-content">
                                    <div className="section-title">
                                        <h2 className="title white">To make requests for further information, contact us</h2>
                                    </div>
                                </div>
                                {/* <!-- Cta Content End --> */}
                            </div>
                            <div className="col-lg-5">
                                {/* <!-- Cta Button Start --> */}
                                <div className="cta-info text-center">
                                    <div className="cta-icon">
                                        <img src="assets/images/cta-icon2.png" alt="" />
                                    </div>
                                    <p>Call Us For Any inquiry</p>
                                    <h3 className="number">+41 920 090 505</h3>
                                </div>
                                {/* <!-- Cta Button End --> */}
                            </div>
                        </div>
                    </div>
                    {/* <!-- Cta Wrap End --> */}
                </div>
            </div>
            {/* <!-- Cta End --> */}

            <Footer />



            {/* <!-- back to top start --> */}
            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
                </svg>
            </div>
            {/* <!-- back to top end --> */}

        </div>
    );
}


export default page;